import { useEffect, useState } from "react";
import DisbursementList from "../../components/DisbursementModule/DisbursementTable/DisbursementList";
import SharedDisbursementList from "../../components/DisbursementModule/DisbursementTable/SharedDisburmentList";
import { CommonHeader } from "../../components/commons";
import { DISBURSEMENT_HEADER } from "../../constant/tableHeadersConstants/disbursementConstants/disbursementTableHeader";
import { useMenuCheck } from "../../customHooks/useMenuCheck";

interface TabsType {
  name: string;
  label: string;
}

type AppProps = {
  history: any;
};

const DisbursementModuleList = ({ history }: AppProps) => {
  const tabs: TabsType[] = [
    {
      name: "Disbursements List",
      label: "Disbursements_list",
    },
    {
      name: "Shared With Me",
      label: "shared_with_me",
    },
  ];
  const [searchData, setSearchData] = useState("");
  const [activeTab, setActiveTab] = useState<any>("");
  const [activeComponent, setActiveComponent] = useState<any>();
  const [finalTab, setFinalTab] = useState(tabs);

  //====================User Management=============================
  const [isAddDisbursementPresent, setIsAddDisbursementPresent] =
    useMenuCheck();

  const [isDisbursementListPresent, setIsDisbursementListPresent] =
    useMenuCheck("Disbursement");
  const [isSharedDisbursementPresent, setIsSharedDisbursementPresent] =
    useMenuCheck("shared");
  //=================================================================
  useEffect(() => {
    setIsAddDisbursementPresent("Add Disbursement Module", "menu");
    setIsDisbursementListPresent("Disbursements", "menu");
    setIsSharedDisbursementPresent("Shared Disbursement List", "menu");
  }, []);

  useEffect(() => {
    if (isDisbursementListPresent && !isSharedDisbursementPresent) {
      setFinalTab([tabs[0]]);
      setActiveTab(tabs[0]?.label);
    } else if (isSharedDisbursementPresent && !isDisbursementListPresent) {
      setFinalTab([tabs[1]]);
      setActiveTab(tabs[1]?.label);
    } else if (!isDisbursementListPresent && !isSharedDisbursementPresent) {
      setFinalTab([]);
    } else {
      setFinalTab([...tabs]);
      setActiveTab(tabs[0]?.label);
    }
  }, [isDisbursementListPresent, isSharedDisbursementPresent]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    let locationTab =
      history &&
      history?.location &&
      history?.location?.state &&
      history?.location?.state
        ? history?.location?.state
        : 0;
    history.push("/disbursement-module", "");
  };

  useEffect(() => {
    let locationTab =
      history &&
      history?.location &&
      history?.location?.state &&
      history?.location?.state
        ? history?.location?.state
        : 0;
    if (locationTab) {
      setActiveTab(locationTab?.tab ? locationTab?.tab : "Disbursements_list");
      if (locationTab?.tab === "Disbursements_list") {
        setActiveComponent(
          <DisbursementList
            tableHeader={DISBURSEMENT_HEADER}
            handleEditDisbursementData={handleEditDisbursementData}
            searchData={searchData}
            activeTab={activeTab}
          />
        );
      } else if (locationTab?.tab === "shared_with_me") {
        setActiveComponent(
          <SharedDisbursementList
            tableHeader={DISBURSEMENT_HEADER}
            handleEditDisbursementData={handleEditDisbursementData}
            searchData={searchData}
            activeTab={activeTab}
          />
        );
      }
      history?.push("/disbursement-module", history?.location?.state);
    } else {
      if (activeTab === "Disbursements_list") {
        setActiveComponent(
          <DisbursementList
            tableHeader={DISBURSEMENT_HEADER}
            handleEditDisbursementData={handleEditDisbursementData}
            searchData={searchData}
            activeTab={activeTab}
          />
        );
      } else if (activeTab === "shared_with_me") {
        setActiveComponent(
          <SharedDisbursementList
            tableHeader={DISBURSEMENT_HEADER}
            handleEditDisbursementData={handleEditDisbursementData}
            searchData={searchData}
            activeTab={activeTab}
          />
        );
      }

      history?.push("/disbursement-module", history?.location?.state);
    }
    if (activeTab === "Disbursements_list") {
      setActiveComponent(
        <DisbursementList
          tableHeader={DISBURSEMENT_HEADER}
          handleEditDisbursementData={handleEditDisbursementData}
          searchData={searchData}
          history={history}
          activeTab={activeTab}
        />
      );
    } else if (activeTab === "shared_with_me") {
      setActiveComponent(
        <SharedDisbursementList
          tableHeader={DISBURSEMENT_HEADER}
          handleEditDisbursementData={handleEditDisbursementData}
          searchData={searchData}
          history={history}
          activeTab={activeTab}
        />
      );
    } else {
      setActiveComponent(
        <DisbursementList
          tableHeader={DISBURSEMENT_HEADER}
          handleEditDisbursementData={handleEditDisbursementData}
          searchData={searchData}
          activeTab={activeTab}
        />
      );
    }
  }, [activeTab]);

  const renderTabs = () => {
    let finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          className={"tab-style mr-4"}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab.label ? "#dd4433" : "",
            }}
            className={`tab-header ${activeTab === tab.label ? "active" : ""}`}
          >
            {tab.name}
          </div>
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTabs;
  };

  const handleEditDisbursementData = (editData: any) => {
    // id: number,attachmentValue?:string,approvalValue?:string
    const data = editData?.data;
    const filterApproval = editData?.approvalValue
      ? editData?.approvalValue
      : "";
    const filterAttachmentValue = editData?.attachmentValue
      ? editData?.attachmentValue
      : "";
    const searchData = editData?.searchData ? editData?.searchData : "";
    const allPaymentStatus = editData?.allPaymentStatus
      ? editData?.allPaymentStatus
      : [];
    const paymentStatus = editData?.paymentStatus
      ? editData?.paymentStatus
      : "";
    history?.push({
      pathname: `/disbursement-module/edit`,
      state: {
        data,
        activeTab,
        filterApproval,
        filterAttachmentValue,
        searchData,
        allPaymentStatus,
        paymentStatus,
      },
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title={`Disbursements`} />
        </div>
        {isAddDisbursementPresent && (
          <div className="col-md-6">
            <div className="d-flex flex-row justify-content-end mr-5">
              {
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    history?.push({
                      pathname: `/disbursement-module/add`,
                      state: { activeTab },
                    })
                  }
                >
                  + Add Disbursement
                </button>
              }
            </div>
          </div>
        )}
      </div>

      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div className="d-flex">{renderTabs()}</div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeComponent}
        </div>
      </div>
    </>
  );
};

export default DisbursementModuleList;
